export default __webpack_public_path__ + "static/media/404.fa2cba53.png";